import React, { Component } from 'react';
import GoogleMapReact from 'google-map-react';
import {Image} from "react-bootstrap";

const AnyReactComponent = ({ text }) => <div>{text}</div>;

class Map extends Component {
    static defaultProps = {
        center: {
            lat: 19.488643,
            lng: -70.657945
        },
        zoom: 11
    };

    render() {
        return (
            // Important! Always set the container height explicitly
            <div style={{ height: '40vh', width: '100%' }}>
                <GoogleMapReact
                /** AIzaSyCkMoayObfarIn063En7ydHhnbIXqW0tLQ */
                    bootstrapURLKeys={{ key: 'AIzaSyC_8Uherd2jLm5nAXAZbQawUOKkapsMoEA' }}
                    defaultCenter={this.props.center}
                    defaultZoom={this.props.zoom}
                >
                    <AnyReactComponent
                        lat={19.488643}
                        lng={-70.657945}
                        text={<Image src={process.env.PUBLIC_URL + 'marker.png'} />}
                    />
                </GoogleMapReact>
            </div>
        );
    }
}

export default Map;